import { forwardRef, Icon, IconProps } from "@chakra-ui/react";
export default forwardRef<IconProps, "svg">((props, svgRef) => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={20}
    fill="none"
    viewBox="0 0 22 20"
    ref={svgRef}
    {...props}
  >
    <path
      fill="currentColor"
      stroke="currentColor"
      strokeWidth={0.5}
      d="M3.942 9.208a.932.932 0 001.275-.055L9.074 5.36h0a.74.74 0 00.236-.633.814.814 0 00-.309-.52c-.308-.246-.824-.326-1.209.053 0 0 0 0 0 0L4.52 7.479 2.73 5.892h0c-.404-.36-.916-.258-1.212.005a.806.806 0 00-.279.536.75.75 0 00.273.62h0l2.43 2.155zm0 0l.166-.187m-.166.187h0l.166-.187m0 0a.682.682 0 00.93-.042l-2.473-2.9c-.583-.518-1.47.27-.887.786l2.43 2.156zm-.166 7.095a.932.932 0 001.275-.055l3.857-3.793h0a.74.74 0 00.236-.633.814.814 0 00-.309-.519c-.308-.246-.824-.327-1.209.053 0 0 0 0 0 0L4.52 14.387l-1.79-1.588h0c-.404-.359-.916-.257-1.212.006a.805.805 0 00-.279.536c-.016.225.076.444.273.62h0l2.43 2.155zm0 0l.166-.187m-.166.187h0l.166-.187m0 0a.681.681 0 00.93-.043l-2.473-2.9c-.583-.517-1.47.27-.887.787l2.43 2.156z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={2}
      d="M13.01 6.21h7.48m-7.48 6.91h7.48"
    />
  </Icon>
));
